var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_812",
    "data-name": "Group 812",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_81",
    "data-name": "Rectangle 81",
    width: 24,
    height: 26,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_812-2",
    "data-name": "Group 812",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M22.266,17.159a3.259,3.259,0,0,1-.767-.611,19.3,19.3,0,0,1-.441-2.382,32.941,32.941,0,0,0-1.976-8.152,6.612,6.612,0,0,0-3.807-3.305c-.183-.069-.371-.125-.558-.183A2.726,2.726,0,0,0,9.28,2.519c-.194.06-.388.118-.579.19A6.608,6.608,0,0,0,4.9,6.014a32.91,32.91,0,0,0-1.976,8.153,19.274,19.274,0,0,1-.441,2.382,3.11,3.11,0,0,1-.754.607C.941,17.681-.516,18.66.185,20.4a2.907,2.907,0,0,0,2.97,1.787c.12,0,.228,0,.321-.006H7.5a4.561,4.561,0,0,0,9,0h3.8l.2,0a3.121,3.121,0,0,0,3.279-1.748c.784-1.741-.71-2.739-1.513-3.274M12,1.733a1.017,1.017,0,0,1,.808.41,9.239,9.239,0,0,0-1.617,0A1.019,1.019,0,0,1,12,1.733m0,22.533A2.845,2.845,0,0,1,9.243,22.18l5.51,0A2.844,2.844,0,0,1,12,24.267M22.22,19.714c-.325.718-.9.758-1.671.735L3.672,20.444l-.244.005c-.923.017-1.4-.073-1.656-.7-.13-.323-.089-.484.9-1.149A3.5,3.5,0,0,0,4.031,17.28a13.481,13.481,0,0,0,.581-2.848,31.785,31.785,0,0,1,1.833-7.68A4.869,4.869,0,0,1,9.3,4.332a7.574,7.574,0,0,1,5.371,0,4.87,4.87,0,0,1,2.859,2.421,31.849,31.849,0,0,1,1.833,7.679,13.436,13.436,0,0,0,.581,2.849,3.531,3.531,0,0,0,1.377,1.326c1.032.689,1.022.829.9,1.108",
    transform: "translate(0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationMail);
export default __webpack_public_path__ + "static/media/notification-mail.c77c4a001e957438b415d580059bb52c.svg";
export { ForwardRef as ReactComponent };